import React from 'react';
import "./styles.scss";

const CopyrightStamp = (props) => {

    return (
        <div className="copyright-wrapper">
            <p className="copyright-stamp">Copyright &#169; 2020 Neurotargeting. All rights reserved  </p>
        </div>
    )

};

export default CopyrightStamp;
